import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { useLocation } from 'react-router-dom';
import { Navigation, Shield, Zap, Wifi, Clock, Globe, Smartphone, DollarSign } from 'lucide-react';
import Hero from '../components/Hero';
import ProductCard from '../components/ProductCard';

const Products = () => {
  const location = useLocation();

  useEffect(() => {
    // Scroll to product section if hash is present
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        setTimeout(() => {
          window.scrollTo({
            top: element.offsetTop - 100,
            behavior: 'smooth'
          });
        }, 100);
      }
    }
  }, [location]);

  return (
    <>
      <Hero 
        title="Nos produits innovants"
        subtitle="Découvrez nos solutions technologiques conçues pour répondre aux défis spécifiques du marché africain."
        imageSrc="https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80"
        imageAlt="Produits AMOGOTech"
      />

      {/* Products Section */}
      <section className="section">
        <div className="container">
          <div className="text-center max-w-3xl mx-auto mb-16">
            <motion.h2 
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
              className="section-title"
            >
              Solutions adaptées aux besoins africains et au reste du monde.
            </motion.h2>
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
              viewport={{ once: true }}
              className="section-subtitle"
            >
              Nos produits sont développés avec un focus sur la performance, la fiabilité et l'accessibilité.
            </motion.p>
          </div>

          <div className="space-y-16">
            <ProductCard 
              id="route-senegal"
              title="Code de la Route Senegal"
              description="Code de la Route Sénégal est une application éducative conçue pour aider les candidats à réussir leur examen du code de la route au Sénégal. Grâce à des leçons interactives, des tests pratiques et des examens blancs conformes aux normes officielles, elle offre une préparation complète et efficace. Suivez vos progrès avec des statistiques détaillées, rejoignez une communauté d’apprenants, et révisez à tout moment grâce à une accessibilité totale sur mobile. Téléchargez dès maintenant l'application sur Play Store et App Store et mettez toutes les chances de votre côté pour obtenir votre code de la route !"
              imageSrc="https://scontent.fdkr6-1.fna.fbcdn.net/v/t39.30808-6/475278056_122210182994192932_1521351567369849701_n.jpg?_nc_cat=111&ccb=1-7&_nc_sid=127cfc&_nc_eui2=AeGsOvkb_FXUpOzdpvRftV6PCwDTROfaH-0LANNE59of7We7mtrN4trh-VswbADI6_jxEBouXFt-w0jrRij-AfWu&_nc_ohc=spbzoc8gNRUQ7kNvgE8hCYn&_nc_oc=Adg0S7FIayY-Bb2HHC3jYLCWE1CIj-DVxnCZgJSOtLYKwXhAvZDU2ZqtNX71MEwGwvw&_nc_zt=23&_nc_ht=scontent.fdkr6-1.fna&_nc_gid=A7EvNNj9oEYwEHHZbz-fxl7&oh=00_AYETAB3nn_5PBEPKLeE171uBBhbCdRfbtAlU4zZooD8DKw&oe=67D4C050"
              features={[
                "Cours de code : Apprenez les règles du code de la route en détail.",
                "Séries de tests : Entraînez-vous à volonté avec des tests variés.",
                "Examens blancs : Testez-vous dans les mêmes conditions que l'examen officiel.",
                "Historique des tests : Consultez vos erreurs pour mieux progresser.",
                "Dossier personnel : Créez votre compte et suivez votre évolution."
              ]}
              
              delay={0.1}
            />

            {/* <ProductCard 
              id="multichange"
              title="Multichange"
              description="MultiChange est une application mobile innovante qui permet de réaliser des transferts d'argent instantanés et sécurisés entre différents réseaux de mobile money. Avec MultiChange, vous pouvez envoyer de l'argent rapidement, de manière fiable et à des frais compétitifs, peu importe le réseau d'origine ou de destination. Grâce à une interopérabilité totale, vous pouvez effectuer des transferts entre des services de mobile money différents, tout en bénéficiant d'une sécurité maximale pour vos transactions. L'application est disponible sur Google Play Store et App Store, et elle permet de simplifier les transferts d'argent à travers une interface intuitive et des technologies de cryptage avancées pour assurer la confidentialité et la sécurité des données."
              imageSrc="https://www.multichange-sn.com/pictureHero.png"
              features={[
                "Transferts instantanés : Envoyez de l'argent en quelques secondes, rapidement et sans tracas.",
                "Interopérabilité totale : Effectuez des transferts d'argent entre différents réseaux de mobile money, sans aucune limitation.",
                "Sécurité maximale : Protégez vos fonds et vos informations personnelles grâce à des technologies de cryptage avancées et des protocoles de sécurité SSL.",
                "Frais compétitifs : Profitez de frais de transfert très abordables, bien plus avantageux que ceux proposés par les autres services.",
                "Support client 24/7 : Un service client disponible à tout moment pour répondre à vos questions et résoudre vos problèmes.",
                "Interface intuitive : Une application facile à utiliser, conçue pour offrir une expérience fluide et rapide sur tous les appareils mobiles.",
                "Suivi des transactions : Suivez vos transferts d'argent en temps réel et consultez l'historique des transactions effectuées."
              ]}
              
              delay={0.2}
            /> */}
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="section bg-gray-50">
        <div className="container">
          <div className="text-center max-w-3xl mx-auto mb-16">
            <motion.h2 
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
              className="section-title text-black"
            >
              Caractéristiques de nos produits
            </motion.h2>
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
              viewport={{ once: true }}
              className="section-subtitle"
            >
              Toutes nos solutions partagent des caractéristiques communes qui assurent leur qualité, leur efficacité et leur adéquation avec les besoins du marché technologique.
            </motion.p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
              viewport={{ once: true, margin: "-100px" }}
              className="bg-white rounded-xl shadow-md p-6"
            >
              <div className="inline-flex items-center justify-center p-3 bg-primary-100 rounded-lg text-primary-600 mb-4">
                <Shield size={24} />
              </div>
              <h3 className="text-xl font-semibold mb-2 text-black">Sécurité renforcée</h3>
              <p className="text-gray-600">
                Protection des données et transactions sécurisées pour garantir la confidentialité de vos informations.
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              viewport={{ once: true, margin: "-100px" }}
              className="bg-white rounded-xl shadow-md p-6"
            >
              <div className="inline-flex items-center justify-center p-3 bg-primary-100 rounded-lg text-primary-600 mb-4">
                <Zap size={24} />
              </div>
              <h3 className="text-xl font-semibold mb-2 text-black">Performance optimisée</h3>
              <p className="text-gray-600">
                Applications légères et rapides, optimisées pour fonctionner sur différents types d'appareils.
              </p>
            </motion.div>

            

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.4 }}
              viewport={{ once: true, margin: "-100px" }}
              className="bg-white rounded-xl shadow-md p-6"
            >
              <div className="inline-flex items-center justify-center p-3 bg-primary-100 rounded-lg text-primary-600 mb-4">
                <Clock size={24} />
              </div>
              <h3 className="text-xl font-semibold mb-2 text-black">Soutien 24/7</h3>
              <p className="text-gray-600">
                Un support technique disponible à toute heure pour résoudre vos problèmes et répondre à vos questions.
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.5 }}
              viewport={{ once: true, margin: "-100px" }}
              className="bg-white rounded-xl shadow-md p-6"
            >
              <div className="inline-flex items-center justify-center p-3 bg-primary-100 rounded-lg text-primary-600 mb-4">
                <Smartphone size={24} />
              </div>
              <h3 className="text-xl font-semibold mb-2 text-black">Mobile-friendly</h3>
              <p className="text-gray-600">
                Toutes nos applications sont optimisées pour offrir la meilleure expérience sur appareils mobiles.
              </p>
            </motion.div>

           
          </div>
        </div>
      </section>
    </>
  );
};

export default Products;
